// Does 1.2.3 style variable access like lodash.get, but without the bloat and lack of types

const lodashStyleGet = <T, Output = never>(obj: T, path: string | string[], defaultValue?: Output): Output|undefined => {
    const keys = Array.isArray(path) ? path : path.replace(/\[(\d+)]/g, '.$1').split('.');
    let result: unknown = obj;

    for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        if (result != null && typeof result === 'object' && (key in result)) {
            result = result[key as keyof typeof result];
        } else {
            return defaultValue;
        }
    }

    return result === undefined ? defaultValue as Output|undefined : result as Output|undefined;
};

export default lodashStyleGet;
